export default function QuestionsPreview({ title, list = [], libraryByEnum }) {
  return (
    <div className="border rounded-lg bg-gray-50 p-4">
      <div className="text-sm font-semibold mb-2">{title}</div>

      {list.length === 0 ? (
        <div className="text-sm text-gray-500">No questions added yet.</div>
      ) : (
        <ol className="list-decimal pl-5 space-y-2">
          {list.map((item, idx) => {
            const q = libraryByEnum?.get?.(item.agent_question_enum);
            return (
              <li
                key={`${item.agent_question_enum}-${idx}`}
                className="text-sm text-gray-800"
              >
                <div className="font-medium">
                  {q?.question ?? item.agent_question_enum}
                </div>

                {q?.rules?.length ? (
                  <div className="text-xs text-gray-600 mt-0.5">
                    Rules: {q.rules.join(" • ")}
                  </div>
                ) : null}
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
